<template>
  <div class="auth-main-content m-0 p-0 overflow-hidden vh-100 d-flex justify-content-center align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-5 col-xl-4">
          <div class="card bg-white border-0 rounded-3 p-4 p-sm-5">
            <div class="text-center mb-4">
              <h2 class="fw-bold text-primary mb-2">Rayacheck Admin</h2>
              <p class="text-secondary">Sign in to your account to continue</p>
            </div>
            
            <form @submit.prevent="handleLogin">
              <div v-if="errorMsg" class="alert alert-danger fs-14 py-2">{{ errorMsg }}</div>
              <div class="mb-3">
                <label class="form-label text-dark fs-14 fw-medium">Email address</label>
                <input type="email" class="form-control" v-model="email" placeholder="admin@jurnalku.com" required />
              </div>
              <div class="mb-4">
                <label class="form-label text-dark fs-14 fw-medium">Password</label>
                <input type="password" class="form-control" v-model="password" placeholder="••••••••" required />
              </div>
              <button type="submit" class="btn btn-primary w-100 py-2 fs-15 fw-medium" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ loading ? 'Signing in...' : 'Sign In' }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import authService from '@/services/authService';

export default defineComponent({
  name: 'LoginPage',
  setup() {
    const email = ref('');
    const password = ref('');
    const errorMsg = ref('');
    const loading = ref(false);
    const router = useRouter();

    const handleLogin = async () => {
      errorMsg.value = '';
      loading.value = true;
      try {
        const response = await authService.login({
          email: email.value,
          password: password.value
        });
        
        if (response.data && response.data.token) {
          localStorage.setItem('auth_token', response.data.token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          router.push('/dashboard');
        }
      } catch (error: any) {
        if (error.response && error.response.data && error.response.data.message) {
          errorMsg.value = error.response.data.message;
        } else {
          errorMsg.value = 'Failed to login. Please check your credentials.';
        }
      } finally {
        loading.value = false;
      }
    };

    return {
      email,
      password,
      errorMsg,
      loading,
      handleLogin
    };
  }
});
</script>
